module.exports = __webpack_public_path__ + "img/tina_h.eda41e39.png";